export default "__VITE_ASSET__BkTpkgrF__"